import { H4 } from "@/components-shared/headers";
import { cn } from "@/lib/utils";
import React from "react";

type Props = {
  children: React.ReactNode;
  className?: string;
};

const SectionHeader = (props: Props) => {
  return (
    <H4
      className={cn(
        "flex gap-5 items-center text-green-main font-semibold",
        props.className
      )}
    >
      {props.children}
    </H4>
  );
};

export default SectionHeader;
